import { FormikSingleSelect } from '~/components/Formik/FormikSingleSelect';
import { IMAGE_SIZE_SINGLE_SELECT } from '~/constants/testIDs';
import { defaultImageSizeOptions } from '../../../ImageFormatFormField';

export type ExportImageSizeSelectProps = {
  setIsEditing: (isFocused: boolean) => void;
};

export const ExportImageSizeSelect = ({ setIsEditing }: ExportImageSizeSelectProps) => {
  return (
    <FormikSingleSelect
      isSearchable={false}
      size="extra-large"
      data-testid={IMAGE_SIZE_SINGLE_SELECT}
      label="Size *"
      name="size"
      options={defaultImageSizeOptions}
      onOptionsClose={() => {
        setIsEditing(false);
      }}
      onOptionsOpen={() => {
        setIsEditing(true);
      }}
    />
  );
};
